<template>
  <el-button type="primary" size="small" @click="onAuth">授权来客商户ID</el-button>
</template>

<script setup lang="ts">
import { useDyLifeBind } from '@/composables/useDyLifeBind';

const props = defineProps<{
  /** 渠道账号 ID（用于绑定生活服务账号） */
  accountId: number;
}>();

const emit = defineEmits<{
  /** 绑定成功后触发，调用方据此重新拉列表 */
  bound: [];
}>();

const { bindDyLifeAccount } = useDyLifeBind();

async function onAuth() {
  if (await bindDyLifeAccount(props.accountId)) emit('bound');
}
</script>
